import { useObservableState } from 'observable-hooks';
import MaskedInput from '../../form/MaskedInput';
import { useWatchObservable } from '../utils';
import { BaseFormFieldContainer } from './FormFieldContainer';

interface FieldOptions {
    name: string;
    settings?: Record<string, unknown>;
}

interface WifiPasswordFieldProps {
    fieldOptions: FieldOptions;
}

function WifiPasswordField({ fieldOptions }: WifiPasswordFieldProps) {
    const { name } = fieldOptions;
    const deviceWifiPassword$ = useWatchObservable<string | null>('sensor.wifiPassword');
    const wifiPassword = useObservableState(deviceWifiPassword$);

    if (!wifiPassword) {
        // Hide the WIFI password field if the value is null (no sensor attached)
        // or when it is '' (no password set for sensor).
        return null;
    }

    return (
        <BaseFormFieldContainer
            name={name}
            label={gettext('WIFI_PASSWORD_LABEL')}
            inline={true}
            Element="li"
        >
            <MaskedInput id={`id_${name}`} value={wifiPassword} type="text" readOnly={true} />
        </BaseFormFieldContainer>
    );
}

export default WifiPasswordField;
